import React from "react";
import Head from "next/head";

import CommissionProgramAgreementMain from "@/components/commission-program-agreement/commission-program-agreement-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const CommissionProgramAgreement = () => {
  return (
    <>
      <Head>
        <title>{seoData.COMMISSION_PROGRAM_AGREEMENT.title}</title>
        <SeoMetaData data={seoData.COMMISSION_PROGRAM_AGREEMENT} />
      </Head>

      <CommissionProgramAgreementMain />
    </>
  );
};

export default CommissionProgramAgreement;
